export const routes = {
  SIGN_UP: '/registration',
  RECOVERY_PASSWORD: '/recovery-password',
  // ссылка из письма-приглашения сотрудника, открывается и без входа
  INVITATION: '/invite/:token',
  // приглашение в команду администраторов площадки
  ADMIN_INVITATION: '/admin-invite/:token',
  MOBILE_APP_PRODUCT: '/products/:id'
}

export const superAdminRoutes = {
  USERS: '/users',
  USERS_ADD: '/users/add',
  USERS_EDIT: '/users/edit/:id',
  SELLERS: '/sellers',
  SELLERS_ADD: '/sellers/add',
  SUPPORT: '/support',
  SELLER: '/sellers/:id',
  SELLER_INFO: '',
  SELLER_SETTINGS: 'settings',
  SELLER_GOODS: 'goods',
  SELLER_ORDERS: 'orders',
  SELLER_SHOPS: 'shops',
  SELLER_DELIVERY: 'delivery',
  SELLER_ACCOUNTING: 'accounting',
  SELLER_EMPLOYEES: 'employees',
  SELLER_MASS_IMPORT: 'mass-import',
  SELLER_API_ONE_C: 'one-c',
  SELLER_API_MOYSKLAD: 'moysklad',
  SELLER_API_INSALES: 'insales',
  SELLER_NOTIFICATIONS: 'notifications',
  SELLER_AI_GOODS: 'ai-goods',
  SELLER_PROMOCODES: 'promocodes',
  SELLER_DISCOUNTS: 'discounts',
  SELLER_REVIEWS: 'reviews',
  SELLER_CHATS: 'chats',
  ORDERS: '/orders',
  ORDER: '/orders/:id',
  COLLECTIONS: '/collections',
  COLLECTIONS_EDIT: '/collections/:id',
  SUPER_ORDER: '/orders/superOrder/:id',
  GOODS: '/goods',
  GOODS_EDIT: '/goods/edit/:id',
  CATEGORIES: '/categories',
  ACTIONS: '/actions',
  ACTIONS_NOTIFICATIONS: 'notifications',
  ACTIONS_WITHDRAWAL_REQUESTS: 'withdrawal-requests',
  ACTIONS_REVIEWS: 'reviews',
  ACTIONS_LOGISTICS: 'logistics',
  ACTIONS_EMPLOYEES: 'employees',
  ACTIONS_SETTINGS: 'settings',
  ACTIONS_FEEDS: 'feeds',
  ACTIONS_AD_LINKS: 'ad-links',
  ACTIONS_ANALYTICS: 'analytics',
  MOBILE_APP_PRODUCT: '/products/:id',
  HORSES: '/horses',
  HORSE: '/horses/:id',
  AI_GOODS: '/ai-goods',
  AI_GOODS_CREATE: '/ai-goods/create/:id',
  AI_GOODS_EDIT: '/ai-goods/edit/:id',
  SETTINGS: '/settings',
  SEO_PAGES: '/seo-pages',
  SEO_PAGES_CREATE: '/seo-pages/create',
  SEO_PAGES_EDIT: '/seo-pages/edit',
  PROMOCODES: '/promocodes',
  PROMOCODES_CREATE: '/promocodes/create/:sellerId?',
  PROMOCODES_EDIT: '/promocodes/edit/:id/:sellerId?',
  DISCOUNTS: '/discounts',
  DISCOUNTS_CREATE: '/discounts/create/:sellerId?',
  DISCOUNTS_EDIT: '/discounts/edit/:id',
  BANNERS: '/banners',
  FEED_SETTINGS: '/feed-settings',
  MAIN: '/main',
  POLO_CLUB: '/polo-club',
  POLO_CLUB_SERVICE_CREATE: '/polo-club/service/create',
  POLO_CLUB_SERVICE_EDIT: '/polo-club/service/edit/:id'
}

export const adminRoutes = {
  GOODS: '/goods',
  GOODS_ADD: '/goods/add',
  GOODS_EDIT: '/goods/edit/:id',
  HORSES: '/horses',
  HORSE: '/horses/:id',
  ORDERS: '/orders',
  ORDER: '/orders/:id',
  PROFILE: '/profile',
  PROFILE_INFO: 'info',
  PROFILE_SHOPS: 'shops',
  PROFILE_DELIVERY: 'delivery',
  PROFILE_ACCOUNTING: 'accounting',
  PROFILE_EMPLOYEES: 'employees',
  PROFILE_MASS_IMPORT: 'mass-import',
  PROFILE_API_ONE_C: 'one-c',
  PROFILE_API_MOYSKLAD: 'moysklad',
  PROFILE_API_INSALES: 'insales',
  PROFILE_NOTIFICATIONS: 'notifications',
  PROFILE_PROMOCODES: 'promocodes',
  PROFILE_DISCOUNTS: 'discounts',
  PROFILE_CHATS: 'chats',
  PROFILE_REVIEWS: 'reviews',
  PROMOCODES_CREATE: '/promocodes/create',
  PROMOCODES_EDIT: '/promocodes/edit/:id',
  DISCOUNTS_CREATE: '/discounts/create',
  DISCOUNTS_EDIT: '/discounts/edit/:id',
  MOBILE_APP_PRODUCT: '/products/:id',
  AI_GOODS: '/ai-goods',
  AI_GOODS_CREATE: '/ai-goods/create/:id',
  AI_GOODS_EDIT: '/ai-goods/edit/:id'
}

export const getRoute = {
  collection_list: '/collections',
  collection_edit: (collectionsId: string) => `/collections/${collectionsId}`
}
